"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowSize = exports.SizeContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
exports.SizeContext = react_1.default.createContext({
    viewports: [],
    size: { height: 0, width: 0 },
});
var WindowSize = function (_a) {
    var children = _a.children, _b = _a.method, method = _b === void 0 ? "throttle" : _b, _c = _a.wait, wait = _c === void 0 ? 500 : _c;
    var sizeContext = (0, hooks_1.useBreakpoint)(wait, method);
    return ((0, jsx_runtime_1.jsx)(exports.SizeContext.Provider, __assign({ value: sizeContext }, { children: children }), void 0));
};
exports.WindowSize = WindowSize;
